import { css } from '@emotion/react';

const form = css`
  padding: 10px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const label = css`
  float: left;
`;

const picturesListContainer = css`
  padding: 0 10px 10px;
`;

const textArea = css`
  width: 100%;
`;

const buttons = css`
  margin-top: auto;
  display: flex;
  flex-direction: row;
  margin-left: auto;
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;
  &&& button {
    margin-top: 5px;
    width: min(200px, 40%);
  }
`;

export default {
  form,
  label,
  picturesListContainer,
  textArea,
  buttons,
};
